export const maxOverlayPreviewSize = 10 * 1024 * 1024;
